module.exports = __webpack_public_path__ + "img/warning.c7238945.png";